import { SchedulesReportHoldingAccount } from "@common/schemas/domains/accounting/schedules-report.schema";
import { SchedulesReportFilterOption } from "@components/pageHeader/filters/Tabs/SchedulesReportFilters/OptionsMultiselectFilter";

export function buildHoldingAccountOptions(
    holdingAccounts: SchedulesReportHoldingAccount[],
): SchedulesReportFilterOption[] {
    return [...holdingAccounts]
        .sort((left, right) => left.code - right.code)
        .map((account) => ({
            id: account.id,
            label: `${account.code} ${account.name}`,
        }));
}
